import { Component, Output, EventEmitter } from '@angular/core';
import { IonicModule } from '@ionic/angular';

@Component({
  selector: 'app-announcement-bar',
  standalone: true,
  imports: [IonicModule],
  templateUrl: './announcement-bar.component.html',
  styleUrl: './announcement-bar.component.scss',
})
export class AnnouncementBarComponent {
  @Output() dismissed = new EventEmitter<void>();

  announcement = {
    message: 'We have partnered with MemberDeals to provide you with exclusive benefits.',
    link: 'https://www.memberdeals.com/realtime/?login=1',
    linkText: 'Visit MemberDeals to get started.',
  };

  dismiss() {
    localStorage.setItem('announcementDismissed', 'true');
    this.dismissed.emit();
  }
}
